import React, { useState, useEffect } from "react";
import "./complainthandeling.css";
import ComplaintModal from "./ComplaintModal";
import { useComplaints } from "../../../hooks/useComplaints";

function ComplaintHandling() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const { complaints, loading, error, getComplaints } = useComplaints();

  useEffect(() => {
    getComplaints();
  }, [getComplaints]);

  const handleOpenModal = (ticket) => {
    setSelectedTicket(ticket);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedTicket(null);
    setIsModalOpen(false);
  };

  const formatTime = (time) => {
    if (!time) return "N/A";
    return new Date(time).toLocaleString();
  };

  if (loading) {
    return (
      <div className="complaint-container">
        <h2 className="order-title">Complaint Handling</h2>
        <hr />
        <div className="loading">Loading support tickets...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="complaint-container">
        <h2 className="order-title">Complaint Handling</h2>
        <hr />
        <div className="error">Error: {error}</div>
      </div>
    );
  }
  return (
    <div className="complaint-container">
      <h2 className="order-title">Complaint Handling</h2>
      <hr />
      <div className="complaints-content">
        {complaints.length === 0 ? (
          <div className="no-tickets">No support tickets found</div>
        ) : (
          complaints.map((ticket, index) => (
            <div
              key={ticket._id || index}
              className="order-card-OnGoingOrders"
              onClick={() => handleOpenModal(ticket)}
              style={{ cursor: "pointer" }}
            >
              <h2
                className="restaurant-name"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                {ticket.restaurant}
                <span className={`status-badge ${ticket.status.toLowerCase()}`}>
                  {ticket.status}
                </span>
              </h2>
              <p className="order-details-OnGoingOrders">
                Request by: {ticket.customerName || "N/A"} | Created At: {formatTime(ticket.createdAt)}
              </p>
              <div className="order-meta-info">
                {/* <p className="order-details-OnGoingOrders">
                  Order Type: {ticket.orderType || "N/A"} | Order Status:{" "}
                  {ticket.orderStatus || "N/A"}
                </p> */}
                {/* {ticket.orderType === "Takeaway" && ticket.pickupTime && (
                  <p className="order-details-OnGoingOrders">
                    Pickup Time: {ticket.pickupTime}
                  </p>
                )} */}
                {/* {ticket.orderType === "Dine-in" && ticket.dineInTime && (
                  <p className="order-details-OnGoingOrders">
                    Dine-in Time: {ticket.dineInTime}
                    {ticket.numberOfPeople && (
                      <span> | People: {ticket.numberOfPeople}</span>
                    )}
                  </p>
                )} */}
                <div className="item-price-OnGoingOrders">
                  {/* <p className="order-details-OnGoingOrders">
                    Total Items: {ticket.totalItems}
                  </p>
                  <p className="order-price-OnGoingOrders">₹{ticket.price}</p> */}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      {isModalOpen && (
        <ComplaintModal
          onClose={handleCloseModal}
          ticket={selectedTicket}
          onUpdate={getComplaints}
        />
      )}
    </div>
  );
}

export default ComplaintHandling;
